










import { Component, Vue } from 'vue-property-decorator';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Upload from '@/components/icons/Upload.vue';

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

@Component({
  components: {
    FilledButton,
    Upload
  }
})
export default class ChooseImage extends Vue {
  get tPrefix() {
    return 'common.components.imageUploadV2';
  }

  onInput(event: HTMLInputEvent) {
    const files = event.target.files || [];

    this.$emit('input', Array.from(files));
  }

  click(event: any) {
    event.preventDefault();

    if (this.$refs.input && (this.$refs.input as HTMLInputElement).click)
      (this.$refs.input as HTMLInputElement).click();
  }
}
